import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { config } from './config';
import { colors, backgroundColors } from './colors';
import { navigation } from './navigation';
import { contactUs } from './pages/contact-us';
import { createAccount } from './pages/create-account';
import { login } from './pages/login';
import { resetPassword } from './pages/reset-password';
import { subscribe } from './pages/subscribe';
import { underMaintenance } from './pages/under-maintenance';
import { unlockAccount } from './pages/unlock-account';
import { accountSettings } from './pages/account-settings';
import { emailPreferences } from './pages/email-preferences';
import { securitySettings } from './pages/security-settings';
import auth from './auth';
import attachments from './attachments';
import taskClock from './taskClock';
import dashboard from './dashboard';
import emailTemplate from './emailTemplate';
import taskHistory from './taskHistory';
import profile from './profile';
import projectAssignment from './projectAssignment';
import projects from './projects';
import quotes from './quotes';
import shops from './shops';
import roles from './roles';
import stageReady from './stageReady';
import tasks from './tasks';
import customer from './customer';
import users from './users';
import jobCards from './jobCards';
import jobCardsTemplate from './jobCardsTemplate';
import alert from './alert';
import modal from './modal';
import reports from './reports';
import objectToDelete from './objectToDelete';
import analytic from './analytic';
import boardSettings from './boardSettings';
import boardLane from './boardLane';
import boardStage from './boardStage';
import archive from './archive';
import vendors from './vendors';
import materials from './materials';
import employees from './employees';
import geo from './geo';
import checkIn from './checkIn';

import { reducer as notificationsReducer } from 'reapop';

const rootReducer = combineReducers({
  config,
  colors,
  backgroundColors,
  navigation,
  contactUs,
  createAccount,
  login,
  resetPassword,
  subscribe,
  underMaintenance,
  unlockAccount,
  accountSettings,
  emailPreferences,
  securitySettings,
  router: routerReducer,
  archive,
  auth,
  attachments,
  taskClock,
  dashboard,
  emailTemplate,
  taskHistory,
  profile,
  projectAssignment,
  projects,
  quotes,
  employees,
  shops,
  roles,
  stageReady,
  tasks,
  customer,
  users,
  jobCards,
  jobCardsTemplate,
  alert,
  modal,
  objectToDelete,
  analytic,
  reports,
  boardSettings,
  boardLane,
  boardStage,
  vendors,
  materials,
  geo,
  checkIn,
  notifications: notificationsReducer()
})
export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js